module.exports = __webpack_public_path__ + "static/media/video-photo.1ec9205d.png";